import { theme } from '@prophecy/theme';
import { Ellipsis } from '@prophecy/ui-v3/Ellipsis';
import { Stack } from '@prophecy/ui-v3/Layout';
import { Card } from '@prophecy/ui-v3/Misc/Card';
import { Text } from '@prophecy/ui-v3/Typography';
import React from 'react';
import styled from 'styled-components';

export const StyledCard = styled(Card)<{ readonly padding?: string; width: string }>`
  border: 1px solid ${theme.colors.gray300};
  border-radius: ${theme.radius.x6};
  padding: ${theme.spaces.x12};
  overflow: hidden;
  width: ${({ width = ' 110px' }) => width};
  &,
  &:hover {
    box-shadow: none !important;
  }
`;

export const StatusCard = ({
  label,
  subText,
  width = '110px',
  hasLabelTooltip,
  hasSubTextTooltip,
  subTextTone = theme.colors.gray500
}: {
  label: React.ReactNode;
  width?: string;
  subText: string;
  hasLabelTooltip?: boolean;
  hasSubTextTooltip?: boolean;
  subTextTone?: string;
}) => {
  return (
    <StyledCard width={width} padding={`${theme.spaces.x10} ${theme.spaces.x12}`}>
      <Stack gap={theme.spaces.x4} alignY='center' align='space-between' width='100%'>
        <Stack width='100%' alignY={hasLabelTooltip ? undefined : 'center'}>
          <Ellipsis tooltip={hasLabelTooltip}>
            <Text level='sm13' weight={theme.fontWeight.semiBold} tone={theme.colors.gray700}>
              {label}
            </Text>
          </Ellipsis>
        </Stack>
        <Stack alignY={hasSubTextTooltip ? undefined : 'center'} width='100%'>
          <Ellipsis tooltip={hasSubTextTooltip}>
            <Text level='sm13' tone={subTextTone}>
              {subText.toUpperCase()}
            </Text>
          </Ellipsis>
        </Stack>
      </Stack>
    </StyledCard>
  );
};
